import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Link, Alert } from "@mui/material";

import Form from "../../Form/Form";
import Input from "../../Form/Input/Input";
import DefaultButton from "../../../components/simple/DefaultButton";
import PageTitle from "../../PageTitle/PageTitle";

import LinearProgress from "@mui/material/LinearProgress";

import { SignUpContainer } from "./style";

import { BrandContext } from "../../../App";

import { useAPI } from "/src/hooks/useAPI";

const MobileNumberWatcher = ({ watch, setMobileNumber }) => {
  const watchedMobile = watch("mobile_number");
  useEffect(() => {
    if (watchedMobile) {
      setMobileNumber(watchedMobile);
    }
  }, [watchedMobile, setMobileNumber]);
  return null;
};

const SignUpInvitedUser = () => {
  const navigate = useNavigate();
  const { brand } = useContext(BrandContext);
  // get token from URL
  const { token } = useParams();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { callAPI } = useAPI();

  const [mobileNumber, setMobileNumber] = useState("");

  const handleSuccess = (data) => {
    // if (
    //   Object.keys(data).includes("mobile_number_masked") &&
    //   data["mobile_number_masked"]
    // ) {
    //   localStorage.setItem(
    //     "2fa_mobile_number_masked",
    //     data["mobile_number_masked"]
    //   );
    //   navigate(`/2fa_init/${data["partial_auth_token"]}`, {
    //     state: { mobile_number: mobileNumber },
    //   });
    // } else {
    //   navigate("/login?signup=1");
    // }
    navigate("/login?signup=1");
  };

  const handleError = (err) => {
    console.log(err);
    setErrorMessage(err);
    setLoading(false);
  };

  const SignUpFields = {
    beforePassword: [
      {
        label: "First Name",
        id: "first_name",
        type: "text",
        error: "First name is required",
      },
      {
        label: "Last Name",
        id: "last_name",
        type: "text",
        error: "Last name is required",
      },
      {
        label: "Job Role",
        id: "job_role",
        type: "text",
        error: "Job role is required",
      },
      {
        label: "Mobile Number",
        id: "mobile_number",
        type: "mobile",
        error: "Mobile number is required",
        helpText:
          "We use your mobile for two-step verification (2FA) to keep your account secure.",
      },
    ],
    password: [
      {
        label: "Password",
        id: "password",
        type: "password",
        error: "Please enter a password",
      },
      {
        label: "Confirm Password",
        id: "confirm_password",
        type: "password",
        error: "Please confirm your password",
      },
    ],
  };

  return (
    <SignUpContainer>
      <div className="signup-invited-user">
        <PageTitle
          text="Finish creating your profile"
          icon={
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.3334 24.5C23.3334 22.8718 23.3334 22.0578 23.1324 21.3953C22.68 19.9039 21.5128 18.7367 20.0214 18.2843C19.3589 18.0833 18.5448 18.0833 16.9167 18.0833H11.0834C9.4552 18.0833 8.64112 18.0833 7.97869 18.2843C6.48722 18.7367 5.32007 19.9039 4.86763 21.3953C4.66669 22.0578 4.66669 22.8718 4.66669 24.5M19.25 8.75C19.25 11.6495 16.8995 14 14 14C11.1005 14 8.75002 11.6495 8.75002 8.75C8.75002 5.8505 11.1005 3.5 14 3.5C16.8995 3.5 19.25 5.8505 19.25 8.75Z"
                stroke="#030039"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        />
        <p>Please fill out your details below</p>
        <Form
          action={`signup`}
          method="POST"
          onSuccess={handleSuccess}
          onBefore={() => setLoading(true)}
          onError={handleError}
        >
          {({ register, formState: { errors }, getValues, control, watch }) => {
            // Watch the password field for changes
            const passwordValue = watch("password", "");

            // Define criteria with validation logic
            const criteriaList = [
              {
                label: "Password must be at least 8 characters long",
                valid: passwordValue.length >= 8,
              },
              {
                label: "Password must include at least one uppercase letter",
                valid: /[A-Z]/.test(passwordValue),
              },
              {
                label: "Password must include at least one special character",
                valid: /[!@#$%^&*(),.?":{}|<>]/.test(passwordValue),
              },
            ];
            return (
              <>
                <MobileNumberWatcher watch={watch} setMobileNumber={setMobileNumber} />
                <input
                  type="hidden"
                  name="token"
                  value={token}
                  {...register("token")}
                />
                {SignUpFields.beforePassword.map((item) => (
                  <Input key={item.id}
                    id={item.id}
                    showLabel
                    label={item.label}
                    type={item.type}
                    placeHolder={item.label}
                    helpText={item.helpText ? item.helpText : null}
                    register={register(item.id, {
                      required: item.error,
                    })}
                    error={errors[item.id]?.message}
                    control={control}
                  />
                ))}
                {SignUpFields.password.map((item) => {
                  const isConfirm = item.id === "confirm_password";
                  return (
                    <Input key={item.id}
                      id={item.id}
                      showLabel
                      label={item.label}
                      type={item.type}
                      placeHolder={item.label}
                      helpText={item.helpText ? item.helpText : null}
                      register={register(item.id, {
                        required: item.error,
                        ...(isConfirm
                          ? {
                              validate: (value) => {
                                const passwordValue = getValues("password");
                                return (
                                  value === passwordValue ||
                                  "Passwords do not match"
                                );
                              },
                            }
                          : {
                              minLength: {
                                value: 8,
                                message:
                                  "Password must be at least 8 characters long",
                              },
                              validate: {
                                hasUppercase: (value) =>
                                  /[A-Z]/.test(value) ||
                                  "Password must include at least one uppercase letter",
                                hasSpecialChar: (value) =>
                                  /[!@#$%^&*(),.?":{}|<>]/.test(value) ||
                                  "Password must include at least one special character",
                              },
                            }),
                      })}
                      error={errors[item.id]?.message}
                    />
                  );
                })}
                <div className="password-critiera">
                  {criteriaList.map((item, index) => (
                    <div key={index}>
                      <span className={`icon ${item.valid ? "active" : ""}`}>
                        <svg
                          width="10"
                          height="7"
                          viewBox="0 0 10 7"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 3.5L3.5 6L8.5 1"
                            stroke="#211F45"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      {item.label}
                    </div>
                  ))}
                </div>
                <div className="utils">
                  <div className="checkboxes">
                    <Input
                      id="agree_privacy"
                      showLabel
                      label={
                        <>
                          <span>By signing up you agree to our</span>
                          <Link
                            href="https://www.gurunow.ai/privacy-policy"
                            target="_blank"
                          >
                            Privacy Policy
                          </Link>
                        </>
                      }
                      type="checkbox"
                      register={register("agree_privacy", {
                        required: "Please agree to the privacy policy",
                      })}
                      error={errors["agree_privacy"]?.message}
                    />
                    <Input
                      id="agree_terms"
                      showLabel
                      label={
                        <>
                          <span>By signing up you agree to our</span>
                          <Link href="/terms">Terms & Conditions</Link>
                        </>
                      }
                      type="checkbox"
                      register={register("agree_terms", {
                        required: "Please agree to the terms & conditions",
                      })}
                      error={errors["agree_terms"]?.message}
                    />
                    <Input
                      id="has_given_2fa_consent"
                      showLabel
                      label="I agree to GuruNow sending me a verification code every time I log in. Message and data rates may apply."
                      type="checkbox"
                      register={register("has_given_2fa_consent")}
                    />
                  </div>
                </div>
                {errorMessage && (
                  <>
                    <Alert severity="error" sx={{ mb: 4 }}>
                      {errorMessage}
                    </Alert>
                  </>
                )}
                <DefaultButton type="submit">Get Started</DefaultButton>
                {loading && (
                  <LinearProgress
                    id="login-loading"
                    color="secondary"
                    sx={{ mt: 5, height: "8px", borderRadius: "6px" }}
                  />
                )}
              </>
            );
          }}
        </Form>
        <div className="register-helper">
          Already have an account?{" "}
          <Link className="register-link" href="/login">
            Login &rarr;
          </Link>
        </div>
      </div>
    </SignUpContainer>
  );
};

export default SignUpInvitedUser;
